import React from 'react';

import { Link } from 'gatsby';
import * as dayjs from 'dayjs';
import styled from 'styled-components';

import Heading from './Heading';
import Subtitle from './Subtitle';
import SanityImage from './SanityImage';
import Button from './Button';

const BoxWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  /*  for buttons and content alignment in bottom */
  .card-content {
    align-items: end;
    height: 100%;
    @media screen and (min-width: 770px) {
      display: grid;
    }
  }
`;

const Card = ({ image, date, title, slug, alt, subtitle }) => {
  return (
    <div className="column is-4">
      <BoxWrapper className="card is-borderless has-text-centered">
        <div className="card-image">
          <SanityImage alt={alt} gatsbyImageData={image} />
        </div>
        <div className="card-content">
          <Heading dark className="title is-5">
            {title}
          </Heading>
          {date && (
            <p className="subtitle mt-2 is-6 has-text-orange has-text-weight-bold">
              {dayjs(date).format('DD MMMM YYYY')}
            </p>
          )}
          <div className="d-grid">
            {subtitle && (
              <Subtitle dark>{`${subtitle.slice(0, 155)} ...`}</Subtitle>
            )}
            <Link to={slug} className="link-wrapper">
              <Button fullWidth>Read more</Button>
            </Link>
          </div>
        </div>
      </BoxWrapper>
    </div>
  );
};

export default Card;
